import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Button,
  Modal,
  Overlay,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { AiFillSave } from "react-icons/ai";
import { TbRelationOneToMany } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FormAutoB } from "../../core/Helper";
import { HttpJsonHeader } from "../../features/Environments";
import {
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import { setReminder } from "../../features/UserActions";
import { HiSaveAs } from "react-icons/hi";

export default function TemplateEditorSaveAs(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [win, setWin, richTextRef, priceData] = props.winState;

  // const [tmpPriceData, setTmpPriceData] = useState(priceData);
  const [templDetail, setDetail] = useState([]); // TemplateDetail
  const [tmpPriceData, setTmpPriceData] = useState([]); //รายการสินค้า
  const [tmpAsscDesc, setAsscDesc] = useState([]);
  const [tmpBranchs, setBranchs] = useState([]); //รายการสาขาที่จะบันทึก
  const [showPop, setShowPop] = useState({
    showGood: false,
    showAssocDesc: false,
    showBranch: false,
  });
  const [goodList, setGoodList] = useState([]);
  const [brchList, setBrchList] = useState([]);

  const refForm1 = useRef();
  const dispatch = useDispatch();
  const refGoods = useRef(null);
  const refAssoDescText = useRef(null);
  const refBranch = useRef(null);

  useEffect(() => {
    // ตั้งค่าเพื่อรับค่ารายการส่วนตรวจสำหรับประกอบ

    if (win && win.show) {
      if (win.templ_id > 0) {
        getOldData();
      } else {
        resetTemp();
      }
    }
  }, [win]);

  const resetTemp = () => {
    let tmp = [];
    priceData.map((r) =>
      tmp.push({ goodid: r.goodid, goodname: r.goodname, templ_good_id: -1 })
    );
    setTmpPriceData(tmp);
    setAsscDesc([]);
    setBranchs([]);
  };

  // ------------------------------------------------------------------------
  // แสดงรายละเอียด Template เมื่อมีการแก้ไข
  const getOldData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/template-result/getdetails",
        {
          UserInfo: userDetail,
          ItemInfo: { templ_id: win.templ_id },
        },
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data) {
          if (res.data.TemplateDetail.length > 0)
            setDetail(res.data.TemplateDetail);
          if (res.data.TemplateBranch.length > 0)
            setBranchs(res.data.TemplateBranch);
          if (res.data.TemplateParts.length > 0)
            setTmpPriceData(res.data.TemplateParts);
          if (res.data.TemplateAssocDesc.length > 0)
            setAsscDesc(res.data.TemplateAssocDesc);
        } else {
          resetTemp();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // ------------------------------------------------------------------------
  const saveTemplate = () => {
    const oFrm1 = Object.fromEntries(new FormData(refForm1.current));
    // const oResult = richTextRef.current.getJsonRaw();
    const oResult = richTextRef.current.value;

    if (oFrm1.templ_name === "") {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาระบุชื่อ Template",
          type: "error",
        })
      );
      return;
    }
    if (oFrm1.templ_keyword === "") {
      dispatch(
        setReminder({ show: true, message: "กรุณาระบุ keyword", type: "error" })
      );
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/template-result/save-template-as",
        {
          UserInfo: userDetail,
          StudyInfo: props.selectedRow,
          TemplateInfo: { ...oFrm1, templ_id: win.templ_id },
          ResultText: oResult,
          TmpBrchInfo: tmpBranchs,
          TmpAssocDescInfo: tmpAsscDesc,
          TmpGoodInfo: tmpPriceData,
        },
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        win.action();
      })
      .catch((err) => {
        dispatch(
          setReminder({
            show: true,
            message: err.response.data.mesg,
            type: "error",
          })
        );
      });
  };
  // --------------- Good -------------------------------------------------
  const addPart = (row) => {
    setShowPop((pv) => {
      return { ...pv, showGood: false };
    });

    for (let i = 0; i < tmpPriceData.length; i++) {
      if (row.goodid === tmpPriceData[i].goodid) {
        refGoods.current.value = "";
        return;
      }
    }
    setTmpPriceData((pv) => [...pv, { ...row, templ_good_id: -1 }]);
    refGoods.current.value = "";
  };
  // ------------------------------------------------------------------------
  const removePart = (e) => {
    setTmpPriceData(
      (pv) =>
        pv &&
        pv.filter((r) => {
          return r.goodid !== e[0];
        })
    );
  };
  // -------------------------------------------------------------------------
  const textGoodChanged = (e) => {
    if (!showPop.showGood) {
      setShowPop({ showGood: true, showAssocDesc: false, showBranch: false });
    }
    if (e.target.value === "") {
      setGoodList([]);
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/search-good",
        {
          UserInfo: userDetail,
          SearchInfo: e.target.value,
        },
        HttpJsonHeader
      )
      .then((r) => {
        setGoodList(r.data.rows);
      })
      .catch();
  };
  // ---------Association Description ---------------------------------
  const addAssoDescItem = (value) => {
    for (let i = 0; i < tmpAsscDesc.length; i++) {
      if (value === tmpAsscDesc[i].assoc_desc_text) {
        refAssoDescText.current.value = "";
        return;
      }
    }
    setAsscDesc((pv) => [
      ...pv,
      { templ_studydesc_id: -1, assoc_desc_text: value },
    ]);
    refAssoDescText.current.value = "";
  };

  // ลบ assoc study decription
  const removeAssoc = (text) => {
    setAsscDesc(
      (pv) =>
        pv &&
        pv.filter((r) => {
          return r.assoc_desc_text !== text;
        })
    );
  };
  // ---------Branch ---------------------------------
  const addฺBranch = (row) => {
    setShowPop((pv) => {
      return { ...pv, showBranch: false };
    });
    for (let i = 0; i < tmpBranchs.length; i++) {
      if (row.brchid === tmpBranchs[i].brchid) {
        refBranch.current.value = "";
        return;
      }
    }
    setBranchs((pv) => [...pv, { ...row, templ_brch_id: -1 }]);
    refBranch.current.value = "";
  };
  // ลบสาขาที่เกี่ยวข้อง
  const removeBranch = (e) => {
    setBranchs(
      (pv) =>
        pv &&
        pv.filter((r) => {
          return r.brchid !== e[0];
        })
    );
  };
  // -----------------
  const textBranchChanged = (e) => {
    if (!showPop.showGood) {
      setShowPop({ showGood: false, showBranch: true });
    }
    if (e.target.value === "") {
      setBrchList([]);
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/branch/search-branch",
        {
          UserInfo: userDetail,
          SearchInfo: e.target.value,
        },
        HttpJsonHeader
      )
      .then((r) => {
        setBrchList(r.data.rows);
      })
      .catch();
  };

  // -------

  const FIELD_Group1 = [
    {
      label: "Template Name",
      oName: "templ_name",
      require: true,
      type: "text",
    },
    { label: "Keyword", oName: "templ_keyword", require: true, type: "text" },
  ];
  // ------------------------------------------------------------------------
  return (
    <MyModal
      show={win.show}
      size="lg"
      onHide={() => setWin({ show: false })}
      keyboard={false}
      backdrop="static"
      centered
    >
      <ModalHeaderBlack style={Styles.modalHeader} closeButton>
        <HiSaveAs style={Styles.buttonImageBig} /> Save Template As ..
      </ModalHeaderBlack>
      <FormAutoB
        {...{
          formId: "form1",
          items: FIELD_Group1,
          refTo: refForm1,
          data: templDetail.length > 0 && templDetail[0],
        }}
      />
      <HBox>
        <Accordion
          defaultActiveKey={["0", "1", "2"]}
          alwaysOpen
          style={{ flex: "1", minHeight: "350px" }}
          onSelect={() => {
            setShowPop({ showGood: false, showBranch: false });
          }}
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <TbRelationOneToMany style={Styles.buttonImage} /> Association
              Part
            </Accordion.Header>
            <Accordion.Body style={Styles.accordionBody}>
              <VBox style={Styles.accordionVBox}>
                <HBox>
                  <div style={Styles.childContainer}>
                    {tmpPriceData &&
                      tmpPriceData.map((item, i) => {
                        return (
                          <SpanText>
                            <span style={{ marginTop: "3px" }}>
                              {item.goodname}
                            </span>
                            <OverlayTrigger
                              placement="top"
                              overlay={(props) => (
                                <Tooltip {...props}>ลบ</Tooltip>
                              )}
                            >
                              <SpanBadge
                                onClick={() =>
                                  removePart([item.goodid, item.templ_good_id])
                                }
                              >
                                x
                              </SpanBadge>
                            </OverlayTrigger>
                          </SpanText>
                        );
                      })}

                    <TextInput
                      placeholder="..Add new part"
                      type="text"
                      onChange={(e) => {
                        textGoodChanged(e);
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" ||
                          e.key === "Escape" ||
                          e.key === "Delete"
                        )
                          setShowPop((pv) => {
                            return {
                              ...pv,
                              showGood: false,
                              showAssocDesc: false,
                            };
                          });
                      }}
                      ref={refGoods}
                    />
                    <Overlay
                      show={showPop.showGood}
                      target={refGoods.current}
                      placement="bottom"
                    >
                      <PopSearch>
                        {goodList.length > 0 &&
                          goodList.map((r) => {
                            return (
                              <ItemChooser onClick={() => addPart(r)}>
                                {r.goodname}
                              </ItemChooser>
                            );
                          })}
                      </PopSearch>
                    </Overlay>
                  </div>
                </HBox>
              </VBox>
            </Accordion.Body>
          </Accordion.Item>
          {/* --------------------------- ITEM ---------------------- */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <TbRelationOneToMany style={Styles.buttonImage} /> Association
              Study Description
            </Accordion.Header>
            <Accordion.Body style={Styles.accordionBody}>
              <VBox style={Styles.accordionVBox}>
                <HBox>
                  <div style={Styles.childContainer}>
                    {tmpAsscDesc &&
                      tmpAsscDesc.map((item, i) => {
                        return (
                          <SpanText>
                            <span style={{ marginTop: "3px" }}>
                              {item.assoc_desc_text}
                            </span>
                            <OverlayTrigger
                              placement="top"
                              overlay={(props) => (
                                <Tooltip {...props}>ลบ</Tooltip>
                              )}
                            >
                              <SpanBadge
                                onClick={() =>
                                  removeAssoc(item.assoc_desc_text)
                                }
                              >
                                x
                              </SpanBadge>
                            </OverlayTrigger>
                          </SpanText>
                        );
                      })}

                    <TextInput
                      placeholder="..Add new item"
                      type="text"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") addAssoDescItem(e.target.value);
                      }}
                      ref={refAssoDescText}
                    />
                  </div>
                </HBox>
              </VBox>
            </Accordion.Body>
          </Accordion.Item>
          {/* --------------------------- ITEM ---------------------- */}
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <TbRelationOneToMany style={Styles.buttonImage} />
              มีผลกับสาขา/รพ.
            </Accordion.Header>
            <Accordion.Body style={Styles.accordionBody}>
              <VBox style={Styles.accordionVBox}>
                <HBox>
                  <div style={Styles.childContainer}>
                    {tmpBranchs &&
                      tmpBranchs.map((item, i) => {
                        return (
                          <SpanText>
                            <span style={{ marginTop: "3px" }}>
                              {item.brchname}
                            </span>
                            <OverlayTrigger
                              placement="top"
                              overlay={(props) => (
                                <Tooltip {...props}>ลบ</Tooltip>
                              )}
                            >
                              <SpanBadge
                                onClick={() =>
                                  removeBranch([
                                    item.brchid,
                                    item.templ_brch_id,
                                  ])
                                }
                              >
                                x
                              </SpanBadge>
                            </OverlayTrigger>
                          </SpanText>
                        );
                      })}

                    <TextInput
                      placeholder="..เพิ่ม สาขา/รพ.ที่เกี่ยวข้อง"
                      type="text"
                      onChange={(e) => {
                        textBranchChanged(e);
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" ||
                          e.key === "Escape" ||
                          e.key === "Delete"
                        )
                          setShowPop((pv) => {
                            return {
                              ...pv,
                              showGood: false,
                              showBranch: false,
                            };
                          });
                      }}
                      ref={refBranch}
                    />
                    <Overlay
                      show={showPop.showBranch}
                      target={refBranch.current}
                      placement="bottom"
                    >
                      <PopSearch>
                        {brchList.length > 0 &&
                          brchList.map((r) => {
                            return (
                              <ItemChooser onClick={() => addฺBranch(r)}>
                                {r.brchname}
                              </ItemChooser>
                            );
                          })}
                      </PopSearch>
                    </Overlay>
                  </div>
                </HBox>
              </VBox>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {/* <VBox style={Styles.vboxFlex}>
                  <div style={Styles.vboxTableHeader}>ส่วนตรวจ</div>
                  <TemplateParts />
               </VBox>
               <VBox style={Styles.vboxFlex}>
                  <div style={Styles.vboxTableHeader}>Association Study Descriptions</div>
                  <TemplateStudyDesc />
               </VBox> */}
      </HBox>

      <ModalFooterBlack>
        <HBox style={Styles.footerbar}>
          <Button
            onClick={() => {
              saveTemplate();
            }}
          >
            <AiFillSave style={Styles.buttonImage} />
            Save Template
          </Button>
          <Button variant="danger" onClick={() => setWin({ show: false })}>
            ปิด
          </Button>
        </HBox>
      </ModalFooterBlack>
    </MyModal>
  );
}

const Styles = {
  modalHeader: {},
  vboxFlex: { flex: "1" },
  vboxTableHeader: { textAlign: "center", color: "#908686" },
  accordionBody: { background: "#222222", padding: "0 0 0 0px" },
  accordionVBox: {
    width: "100%",
    minHeight: "270px",
    overflowY: "scroll",
  },
  buttonTemplate: { marginRight: "5px" },
  buttonSub: {
    height: "27px",
    width: "30px",
    padding: "0 0 0 0px",
    margin: "5px",
  },
  badge: { margin: "0px 2px 5px 5px", cursor: "pointer" },
  footerbar: { justifyContent: "flex-end" },
  buttonImage: {
    marginRight: "5px",
    color: "yellow",
    height: "30px",
    width: "30px",
  },
  buttonImageBig: {
    marginRight: "5px",
    color: "yellow",
    height: "40px",
    width: "40px",
  },
  textSearch: {
    border: "none",
    display: "inline-block",
    marginTop: "5px",
    background: "none",
    color: "green",
  },
  childContainer: { paddingTop: "10px" },
};

const SpanText = styled.div`
  font-size: 16px;
  color: white;
  border: 1px solid yellow;
  margin: 0 5px 2px 5px;
  padding: 0 5px 5px 5px;
  border-radius: 5px;
  line-height: 25px;
  display: inline-flex;
  &:hover {
    border: 1px solid red;
    /* cursor: pointer; */
  }
`;

const SpanBadge = styled.span`
  background-color: red;
  padding: 0.35em 0.65em;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  /* vertical-align: baseline; */
  border-radius: 0.25rem;
  margin-left: 5px;
  margin-top: 5px;
  display: none;
  ${SpanText}:hover & {
    display: inline-block;
  }
  &:hover {
    cursor: pointer;
  }
`;

const HBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const PopSearch = styled.div`
  position: absolute;
  z-index: 1060;
  color: #121212;
  background: #323030;
  max-height: 300px;
  min-width: 250px;
  border-radius: 2px;
  box-shadow: var(--shadow-panel);
  overflow-y: scroll;
`;

const ItemChooser = styled.div`
  border: 1px solid #ffffff;
  cursor: pointer;
  color: #e2dff4;
  padding: 1px 3px 1px 10px;
  &:hover {
    background-color: #4212ec;
  }
`;

const TextInput = styled.input`
  border: none;
  display: inline-block;
  padding: 1px 5px 1px 10px;

  background: none;
  color: #aef703;
  line-break: unset;
  &:active {
    border: none;
  }
  &:focus {
    outline: none;
  }
`;
